import { Col } from '@busybusy/webapp-react-ui';
import * as React from 'react';
import { useState } from 'react';
import { ErrorState, LoadingState } from '../../../../components';
import './PhotoFullscreen.scss';
import classNames from 'classnames';
import { IFullscreenAttachment } from 'components/domain/attachment/AttachmentFullscreenViewer/AttachmentFullscreenViewer';

export interface IPhotoFullScreenProps {
  photo?: IFullscreenAttachment;
  performShake: boolean;
  showAnnotations?: boolean;
  annotationFileUrl?: string;
}

const PhotoFullScreen: React.FunctionComponent<IPhotoFullScreenProps> = (props) => {
  const { photo, performShake, showAnnotations, annotationFileUrl } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);
  const classes = classNames('photo-full-screen', 'image-container', {
    'ac-shake': performShake,
  });

  function handleImageFinishedLoading() {
    setIsLoading(false);
  }

  function handleImageErrorLoading() {
    setError(true);
  }

  return (
    <Col className={classes}>
      <div className="image">
        {photo && (
          <img
            src={showAnnotations && annotationFileUrl ? annotationFileUrl : photo.fileUrl!}
            onLoad={handleImageFinishedLoading}
            onError={handleImageErrorLoading}
            alt=""
          />
        )}
      </div>
      {isLoading && !error ? <LoadingState /> : null}
      {error && <ErrorState />}
    </Col>
  );
};

export default PhotoFullScreen;
